document.addEventListener('DOMContentLoaded', function () {

  // Toggle menu movil
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
    });
  }

  // Toggle buscador
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchDrawer = document.querySelector('[data-search-drawer]');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      searchDrawer.hidden = !searchDrawer.hidden;
    });
  }
  if (searchClose && searchDrawer) {
    searchClose.addEventListener('click', function () {
      searchDrawer.hidden = true;
    });
  }

  // Carrito drawer (cierre)
  var cartDrawerClose = document.querySelector('[data-cart-drawer-close]');
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawerClose && cartDrawer) {
    cartDrawerClose.addEventListener('click', function () {
      cartDrawer.hidden = true;
    });
  }

  // Añadir al carrito via AJAX (progresivo, cae a submit normal si falla)
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fallback normal
      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('[data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
          if (cartDrawer) cartDrawer.hidden = false;
        })
        .catch(function () {
          form.submit();
        });
    });
  });

});
